var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.noDataShow),expression:"noDataShow"}],staticClass:"no-data-wrap"},[_c('img',{attrs:{"src":require("../../assets/img/common/no_result.png"),"width":"240","height":"140"}}),_vm._v(" "),_c('p',{staticClass:"no-ps"},[_vm._v("暂无记录")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-2c08881a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/noData.vue
// module id = wdOA
// module chunks = 5